var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronLeftTest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 24,
    viewBox: "0 0 15 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.125 11.9984L1.18437 13.0578L10.1844 22.0578L11.2484 23.1219L13.3719 20.9984L12.3125 19.9391L4.37188 11.9984L12.3078 4.05781L13.3719 2.99844L11.2484 0.875L10.1891 1.93906L1.18906 10.9391L0.125 11.9984Z",
    fill: "#091644"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeftTest);
export default __webpack_public_path__ + "static/media/chevron-left-test.6d222621b8deaec04840373eb22e90cd.svg";
export { ForwardRef as ReactComponent };